import React from 'react';
import { render } from 'react-dom';
import App from './containers/App/App';

import 'react-datepicker/dist/react-datepicker.css';
import "react-activity/dist/library.css";
import 'tippy.js/dist/tippy.css';

render(
  <App />,
  document.getElementById('root'),
);
